import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query-client';
import { RouterProvider } from 'react-router-dom';
import { router } from './App';
import { UiProvider } from './components/ui-dialogs';
import { registerUpdateGate } from './features/update-gate';
import './styles/globals.css';
import './styles/themes.css';

registerUpdateGate();

// ---- iOS "Add to Home Screen" hint (iPhone Safari, not already installed) ----
function maybeShowIOSInstallHint() {
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const standalone =
    window.matchMedia?.('(display-mode: standalone)').matches ||
    (navigator as any).standalone === true;
  if (!isIOS || standalone) return;
  if (localStorage.getItem('bmail-a2hs-dismissed')) return;
  window.addEventListener('load', () => {
    const b = document.createElement('div');
    b.style.cssText = 'position:fixed;bottom:calc(1rem + env(safe-area-inset-bottom));left:1rem;right:1rem;z-index:9998;background:#0b1a2e;color:#fff;border:1px solid #c9a96e;border-radius:12px;padding:12px 14px;display:flex;gap:10px;align-items:center;font:14px system-ui';
    b.innerHTML = '<span style="font-size:18px">􀈂</span><span>Install B-Mail: tap <b>Share</b> <span style="opacity:.7">(􀈂)</span> then <b>Add to Home Screen</b></span>';
    const x = document.createElement('button');
    x.textContent = '✕';
    x.style.cssText = 'margin-left:auto;background:none;border:0;color:#fff;opacity:.6;font-size:16px;cursor:pointer';
    x.onclick = () => { localStorage.setItem('bmail-a2hs-dismissed', '1'); b.remove(); };
    b.appendChild(x);
    document.body.appendChild(b);
    setTimeout(() => b.remove(), 15_000);
  });
}
maybeShowIOSInstallHint();


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <UiProvider>
        <RouterProvider router={router} />
      </UiProvider>
    </QueryClientProvider>
  </StrictMode>
);
